<ng-container *ngFor="let groupedDisclosures of groupedDisclosuresByCategory | keyvalue">
  <app-disclosure-icon *ngIf="groupedDisclosures.key"
    [disclosureCategory]="groupedDisclosures.key"
    [disclosures]="groupedDisclosures.value"
    [isCollapsed]="isCollapsed"
  >
  </app-disclosure-icon>
</ng-container>
